// Auto-generated by scripts/version-bump.js. Do not edit by hand.
export const BUILD_INFO = Object.freeze({
  "major": 1,
  "minor": 18,
  "build": "2607050713",
  "version": "1.18.2607050713",
  "builtAt": "2026-07-05T07:13:29.858Z"
});
